// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sg-intro-text {
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0 0 1rem;
  font-size: 0.95rem;
}

.sg-category {
  margin-bottom: 1rem;
}

.sg-category-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.35rem;
  padding: 0.4rem 0;
  border-bottom: 1px solid var(--border-primary);
}

.sg-category-icon {
  font-size: 1rem;
}

.sg-category-description {
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--text-secondary);
  margin: 0 0 0.5rem;
  padding: 0.4rem 0;
}

.sg-accordion-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.sg-accordion-item {
  border-radius: 4px;
  overflow: hidden;
  background: var(--bg-primary);
}

.sg-accordion-item + .sg-accordion-item {
  border-top: 1px solid var(--border-primary);
}

.sg-accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.45rem 0.65rem;
  background: transparent;
  border: none;
  color: var(--text-primary);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;
  font-family: inherit;
  line-height: 1.35;
}

.sg-accordion-header:hover {
  background: var(--bg-tertiary);
}

.sg-accordion-open .sg-accordion-header {
  background: var(--bg-tertiary);
  font-weight: 600;
}

.sg-accordion-name {
  flex: 1;
  min-width: 0;
}

.sg-accordion-arrow {
  flex-shrink: 0;
  font-size: 0.8rem;
  color: var(--text-tertiary);
  margin-left: 0.5rem;
  transition: transform 0.2s ease;
}

.sg-accordion-body {
  padding: 0.4rem 0.65rem 0.6rem;
  font-size: 0.82rem;
  line-height: 1.5;
  color: var(--text-secondary);
  border-top: 1px solid var(--border-primary);
  background: var(--bg-primary);
}

.sg-accordion-body p {
  margin: 0 0 0.25rem;
}

.sg-accordion-body p:last-child {
  margin-bottom: 0;
}

.sg-related-link {
  display: inline-block;
  margin-top: 0.25rem;
  font-size: 0.8rem;
}

.sg-troubleshoot-item {
  background: var(--bg-primary);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  border-left: 3px solid var(--accent-primary);
}

.sg-troubleshoot-item h3 {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.4rem;
}

.sg-troubleshoot-item p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0 0 0.3rem;
}

.sg-troubleshoot-item p:last-child {
  margin-bottom: 0;
}

@media (max-width: 680px) {
  .sg-accordion-header {
    padding: 0.4rem 0.5rem;
    font-size: 0.82rem;
  }

  .sg-accordion-body {
    padding: 0.35rem 0.5rem 0.5rem;
    font-size: 0.8rem;
  }

  .sg-category-title {
    font-size: 0.9rem;
    padding: 0.3rem 0;
  }

  .sg-troubleshoot-item {
    padding: 0.75rem;
  }

  .sg-troubleshoot-item h3 {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/guides/SettingsGuidePage.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".sg-intro-text {\r\n  color: var(--text-secondary);\r\n  line-height: 1.6;\r\n  margin: 0 0 1rem;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.sg-category {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.sg-category-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 0.35rem;\r\n  padding: 0.4rem 0;\r\n  border-bottom: 1px solid var(--border-primary);\r\n}\r\n\r\n.sg-category-icon {\r\n  font-size: 1rem;\r\n}\r\n\r\n.sg-category-description {\r\n  font-size: 0.85rem;\r\n  line-height: 1.5;\r\n  color: var(--text-secondary);\r\n  margin: 0 0 0.5rem;\r\n  padding: 0.4rem 0;\r\n}\r\n\r\n.sg-accordion-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n}\r\n\r\n.sg-accordion-item {\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.sg-accordion-item + .sg-accordion-item {\r\n  border-top: 1px solid var(--border-primary);\r\n}\r\n\r\n.sg-accordion-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  padding: 0.45rem 0.65rem;\r\n  background: transparent;\r\n  border: none;\r\n  color: var(--text-primary);\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  transition: background 0.15s ease;\r\n  font-family: inherit;\r\n  line-height: 1.35;\r\n}\r\n\r\n.sg-accordion-header:hover {\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.sg-accordion-open .sg-accordion-header {\r\n  background: var(--bg-tertiary);\r\n  font-weight: 600;\r\n}\r\n\r\n.sg-accordion-name {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.sg-accordion-arrow {\r\n  flex-shrink: 0;\r\n  font-size: 0.8rem;\r\n  color: var(--text-tertiary);\r\n  margin-left: 0.5rem;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.sg-accordion-body {\r\n  padding: 0.4rem 0.65rem 0.6rem;\r\n  font-size: 0.82rem;\r\n  line-height: 1.5;\r\n  color: var(--text-secondary);\r\n  border-top: 1px solid var(--border-primary);\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.sg-accordion-body p {\r\n  margin: 0 0 0.25rem;\r\n}\r\n\r\n.sg-accordion-body p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.sg-related-link {\r\n  display: inline-block;\r\n  margin-top: 0.25rem;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.sg-troubleshoot-item {\r\n  background: var(--bg-primary);\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  margin-bottom: 0.75rem;\r\n  border-left: 3px solid var(--accent-primary);\r\n}\r\n\r\n.sg-troubleshoot-item h3 {\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 0.4rem;\r\n}\r\n\r\n.sg-troubleshoot-item p {\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n  line-height: 1.5;\r\n  margin: 0 0 0.3rem;\r\n}\r\n\r\n.sg-troubleshoot-item p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n@media (max-width: 680px) {\r\n  .sg-accordion-header {\r\n    padding: 0.4rem 0.5rem;\r\n    font-size: 0.82rem;\r\n  }\r\n\r\n  .sg-accordion-body {\r\n    padding: 0.35rem 0.5rem 0.5rem;\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .sg-category-title {\r\n    font-size: 0.9rem;\r\n    padding: 0.3rem 0;\r\n  }\r\n\r\n  .sg-troubleshoot-item {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .sg-troubleshoot-item h3 {\r\n    font-size: 0.9rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
